var map = {
	"./1-diversityServiceIcon.svg": 87808,
	"./2-QRIS.svg": 93182,
	"./3-transferIcon.svg": 20821,
	"./4-Safety.svg": 36756,
	"Components/HomePage/Components/03-InfoIconsSection/Assets/Icons/1-diversityServiceIcon.svg": 87808,
	"Components/HomePage/Components/03-InfoIconsSection/Assets/Icons/2-QRIS.svg": 93182,
	"Components/HomePage/Components/03-InfoIconsSection/Assets/Icons/3-transferIcon.svg": 20821,
	"Components/HomePage/Components/03-InfoIconsSection/Assets/Icons/4-Safety.svg": 36756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85093;